.form {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--color-bone);
  padding: 22px;
  border-radius: 12px;
}

.field { display: flex; flex-direction: column; gap: 6px; }

.label {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-ink);
}

.label em { color: var(--color-ember-dark); margin-left: 4px; font-style: normal; }

.input, .textarea {
  border: 1px solid rgba(0, 0, 0, 0.18);
  background: #fff;
  padding: 10px 12px;
  font: inherit;
  font-size: 0.95rem;
  border-radius: 4px;
  outline: none;
}

.input:focus, .textarea:focus {
  border-color: var(--color-ember);
  box-shadow: 0 0 0 3px rgba(243, 154, 46, 0.18);
}

.textarea { resize: vertical; min-height: 110px; }

.grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.submit {
  align-self: flex-start;
  background: var(--color-ember);
  color: #111;
  border: 0;
  padding: 14px 22px;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.submit:hover { background: var(--color-ember-dark); color: #fff; }

.sent {
  background: rgba(46, 157, 87, 0.1);
  color: #226c40;
  padding: 18px 20px;
  border-radius: 8px;
}

.sent strong { font-size: 1.05rem; }
.sent p { margin: 4px 0 0; }

@media (max-width: 768px) {
  .grid2 { grid-template-columns: 1fr; }
  .submit { width: 100%; align-self: stretch; text-align: center; }
}
